export default "__VITE_ASSET__CD_ABgEG__"